/**
 * @author lifei & gll & bly
 * 功能：字典
 */
import { Service } from '@/tools'

export class DictService<T extends TUser.Dict> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Dict}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 查询门户列表
   */
  portalList = <K extends T['ApiPortalList']>(): Promise<K['res']> => this.post2('v1/ApiPortalList')

  /**
   * 功能：查询字典分类列表
   */
  typeList = <K extends T['ApiTypeList']>(): Promise<K['res']> => this.post2('v1/ApiTypeList')

  /**
   * 功能：根据分类编码查询字典列表
   */
  dictCodeList = <K extends T['ApiDictCodeList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDictCodeList', data)

  /**
   * 功能：新增字典
   */
  addDict = <K extends T['ApiAddDict']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddDict', data)

  /**
   * 功能：查询分类下字典列表
   */
  dictList = <K extends T['ApiDictList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDictList', data)

  /**
   * 功能：查询分类下字典列表
   */
  updateDict = <K extends T['ApiUpdateDict']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateDict', data)
}
